export default __webpack_public_path__ + "img/cAEVDLyE.8d88c58a.svg";